import moment from 'moment-timezone';
import { useEffect, useRef } from 'react';
import './NewsStory.css';
import { ReactComponent as CloseIcon } from '../../assets/icons/close-line.svg';
import { ReactComponent as ReutersLogo } from '../../assets/icons/reuters-logo.svg';

interface NewsStoryProps {
  headline: string;
  date: string;
  time: string;
  story: string;
  withCloseButton?: boolean;
  onClose?: () => void;
}

const NewsStory = ({
  headline,
  date,
  time,
  story,
  withCloseButton,
  onClose,
}: NewsStoryProps) => {
  const storyRef: any = useRef(null);

  useEffect(() => {
    if (storyRef.current) {
      storyRef.current.scrollTo(0, 0);
    }
  }, [story]);

  return (
    <div className="story-container">
      <div className="story-content-container">
        {withCloseButton && (
          <div className="story-close-sticky">
            <button onClick={onClose} className="story-close-button">
              <CloseIcon />
            </button>
          </div>
        )}
        <div className="story-header">
          <div className="story-headline-container">
            <div className="story-headline">{headline}</div>
          </div>
          <div className="story-meta">
            <div className="story-datetime">
              {`${moment(date).format('DD MMM')} ${time}`}
            </div>
            <ReutersLogo className="story-source-logo" />
          </div>
        </div>
        <div
          ref={storyRef}
          className="story-body"
          dangerouslySetInnerHTML={{ __html: story }}
        ></div>
      </div>
    </div>
  );
};

export default NewsStory;
